import { memo } from 'react'
import { isEqual } from 'lodash'
import DashboardNurseContainer from 'app/containers/Dashboard/DashboardNurse'
import { PageTitle } from 'app/components/common/PageTitle'
import { useTranslation } from 'react-i18next'
import R from 'app/assets/R'

const DashboardNurseCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.dashboard_nurse)}</PageTitle>
      <DashboardNurseContainer />
    </>
  )
}
export const DashboardNursePage = memo(DashboardNurseCpn, isEqual)
